import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Label, Select } from '@/components/FormElements';
import { humanize, titleize } from '@/utils/strings';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LAYOUT_POSITIONS = ['left', 'top', 'right', 'bottom', 'center', 'chartArea'];

const EditorFieldsChartJsLegendPosition = _ref => {
  let {
    elementId,
    defaultValue,
    disabled,
    onChange
  } = _ref;
  return /*#__PURE__*/_jsx(Label, _objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: parentStyles.formField,
    text: "Position",
    children: /*#__PURE__*/_jsxs(Select, {
      defaultValue: `${defaultValue}`,
      disabled: disabled === true,
      onChange: evt => {
        // @ts-ignore
        const srcValue = `${evt.target.value || ''}`;
        let value;

        if (!srcValue || srcValue === 'default') {
          value = null;
        } else {
          value = srcValue;
        }

        onChange(value);
      },
      children: [/*#__PURE__*/_jsx("option", {
        value: "default",
        children: "Default"
      }), LAYOUT_POSITIONS.map(value => /*#__PURE__*/_jsx("option", {
        value: `${value}`,
        children: titleize(humanize(`${value}`))
      }, `${value}`))]
    })
  }));
};

export default EditorFieldsChartJsLegendPosition;